module.exports = __webpack_public_path__ + "static/media/AaronGeorgeAbraham.05fdc723.jpg";